import APP_CONFIG from '../../const/AppConfig';
import { validateAddressLine1, validateAddressLine2, validateCity, validateFirstName, validateLastName, validatePhone, validateState, validateZip } from "./ClientSideValidation";
export function setErrors(event, errors) {
  switch (event.target.name) {
    case APP_CONFIG.CHECKOUT_FIELDS.FIRST_NAME:
      validateFirstName(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.LAST_NAME:
      validateLastName(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.ADDRESS_LINE1:
      validateAddressLine1(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.ADDRESS_LINE2:
      validateAddressLine2(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.CITY:
      validateCity(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.STATE:
      validateState(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.POSTAL_CODE:
      validateZip(event.target.value, errors);
      break;

    case APP_CONFIG.CHECKOUT_FIELDS.PHONE_NUMBER:
      validatePhone(event.target.value, errors);
      break;
  }

  return errors;
}
export function checkForm(elements) {
  var allFieldsFilled = true;

  for (var i = 0; i < elements.length; i++) {
    if (elements[i].value === "") {
      allFieldsFilled = false;
      break;
    }
  }

  return allFieldsFilled;
}
export function addressFormat(str) {
  var lowerCaseString = str.replace(/\s+/g, ' ').trim().toLowerCase();
  var array = lowerCaseString.split(" ");

  for (var i = 0; i < array.length; i++) {
    array[i] = array[i].charAt(0).toUpperCase() + array[i].slice(1);
  }

  return array.join(" ");
} //handle null state for military addresses

export function handleMilitaryState(userEnteredState, suggestedState) {
  if (suggestedState == null) {
    if (userEnteredState == "AA" | userEnteredState == "AE" | userEnteredState == "AP") {
      return userEnteredState;
    }
  } else {
    return suggestedState;
  }
}